import { INTERNAL_CART_SOURCE } from "@cart-client/interfaces/Cart";
import { CheckoutActionTypes, CheckoutState } from "@swiggy-private/checkout-core";

export type SelectedCheckoutState =
    | CheckoutActionTypes.SHOW_GIFTING_CART
    | CheckoutActionTypes.SHOW_GIFTING_COUPON_LISTING
    | CheckoutActionTypes.SHOW_MRO_FOOD_CART
    | CheckoutActionTypes.SHOW_MRO_FOOD_COUPON_LISTING
    | CheckoutActionTypes.SHOW_QUICK_CHECKOUT;

// maps internal cart source to checkout state
export const CheckoutStateToCartSourceMap: Record<SelectedCheckoutState, INTERNAL_CART_SOURCE> = {
    [CheckoutActionTypes.SHOW_GIFTING_CART]: INTERNAL_CART_SOURCE.GIFTING,
    [CheckoutActionTypes.SHOW_GIFTING_COUPON_LISTING]: INTERNAL_CART_SOURCE.GIFTING,
    [CheckoutActionTypes.SHOW_MRO_FOOD_CART]: INTERNAL_CART_SOURCE.MRO_FOOD,
    [CheckoutActionTypes.SHOW_MRO_FOOD_COUPON_LISTING]: INTERNAL_CART_SOURCE.MRO_FOOD,
    [CheckoutActionTypes.SHOW_QUICK_CHECKOUT]: INTERNAL_CART_SOURCE.QUICK_CHECKOUT,
};

export const getCartSource = (checkoutState: CheckoutState): INTERNAL_CART_SOURCE => {
    return (
        CheckoutStateToCartSourceMap[checkoutState?.type as SelectedCheckoutState] || INTERNAL_CART_SOURCE.DEFAULT_FOOD
    );
};
